<template>
  <div
    class="overlay"
    tabindex="0"
    @mousedown="close">
    <div
      v-show="isLoading"
      class="loading">
      <img
        src="@/assets/img/loading.svg"
        width="64"
        height="64">
    </div>
    <div
      class="panel"
      @mousedown.stop>
      <div class="header">
        <span class="date">
          <i
            class="material-icons"
            @click="setDate('prev')">navigate_before</i>
          <span class="vertical-text">{{ thisDate | moment('YYYY/MM/DD (ddd)') }}</span>
          <i
            class="material-icons"
            @click="setDate('next')">navigate_next</i>
        </span>
        <span
          v-if="!isMyself"
          class="name vertical-text">{{ userName }}さん</span>
        <span class="menu">
          <span
            v-if="isDiary && isMyself"
            class="menu-label"
            @click="deleteDiary">
            <i
              class="material-icons"
              title="日報を削除">delete_forever</i>
            <span class="menu-label">日報を削除</span>
          </span>
          <span
            v-if="!isDiary && isMyself"
            class="menu-label"
            @click="deleteDraft">
            <i
              class="material-icons"
              title="下書きを破棄">delete</i>
            <span class="menu-label">下書きを破棄</span>
          </span>
          <i
            v-if="isMyself"
            class="vertical-line" />
          <span
            :title="isDiary ? '閉じる' : '下書きを保存して閉じる'"
            class="menu-label"
            @click="close">
            <i class="material-icons">close</i>
            <span class="menu-label">閉じる</span>
          </span>
        </span>
      </div>
      <div class="form">
        <div class="left-form">
          <div class="obj obj-select">
            <span
              v-if="isMyself"
              class="label">報告日</span>
            <span
              v-else
              class="label">参照日</span>
            <span
              v-if="isMyself"
              class="must">【必須】</span>
            <input
              v-model="inputDate"
              :max="$store.state.today | moment('YYYY-MM-DD')"
              type="date"
              class="work-date"
              @change="setDate('this')">
          </div>
          <div
            class="obj obj-time"
            @change="change">
            <span class="label">勤務時間</span>
            <span
              v-if="isMyself"
              class="must">【必須】</span>
            <span class="work-time-start-label">開始時間：</span>
            <input
              v-model="timeStart"
              :disabled="!isMyself"
              type="time"
              class="work-time-start"
              step="300">
            <span class="work-time-end-label">終了時間：</span>
            <input
              v-model="timeEnd"
              :disabled="!isMyself"
              type="time"
              class="work-time-end"
              step="300">
            <span class="work-time-break-label">休憩時間：</span>
            <input
              v-model="timeBreak"
              :disabled="!isMyself"
              type="time"
              class="work-time-break"
              step="300">
          </div>
          <div
            class="obj obj-select"
            @change="change">
            <span class="label">今日の気分</span>
            <span
              v-if="isMyself"
              class="must">【必須】</span>
            <div :class="['feel', { 'myFeel': isMyself }]">
              <input
                id="feel1"
                v-model="feel"
                :disabled="!isMyself"
                type="radio"
                value="5" />
              <label for="feel1"><i class="material-icons-outlined sentiment_very_satisfied">sentiment_very_satisfied</i></label>
              <input
                id="feel2"
                v-model="feel"
                :disabled="!isMyself"
                type="radio"
                value="4" />
              <label for="feel2"><i class="material-icons-outlined mood">mood</i></label>
              <input
                id="feel3"
                v-model="feel"
                :disabled="!isMyself"
                type="radio"
                value="3" />
              <label for="feel3"><i class="material-icons-outlined sentiment_satisfied">sentiment_satisfied</i></label>
              <input
                id="feel4"
                v-model="feel"
                :disabled="!isMyself"
                type="radio"
                value="2" />
              <label for="feel4"><i class="material-icons-outlined sentiment_dissatisfied">sentiment_dissatisfied</i></label>
              <input
                id="feel5"
                v-model="feel"
                :disabled="!isMyself"
                type="radio"
                value="1" />
              <label for="feel5"><i class="material-icons-outlined sentiment_very_dissatisfied">sentiment_very_dissatisfied</i></label>
            </div>
          </div>
          <div
            class="obj-input"
            @change="change">
            <div class="obj-header">
              <span class="label">今日の実績</span>
              <span
                v-if="isMyself"
                class="must">【必須】</span>
            </div>
            <textarea
              id="actual"
              v-model="actual"
              :disabled="!isMyself"
              type="text"
              placeholder="今日の実績" />
          </div>
          <div
            class="obj-input"
            @change="change">
            <div class="obj-header">
              <span class="label">総括</span>
            </div>
            <textarea
              id="summary"
              v-model="summary"
              :disabled="!isMyself"
              type="text"
              placeholder="総括" />
          </div>
        </div>
        <div
          class="right-form"
          @change="change">
          <span class="obj-input">
            <div class="obj-header">
              <span class="label">特記事項／相談事</span>
            </div>
            <textarea
              id="note"
              v-model="note"
              :disabled="!isMyself"
              type="text"
              placeholder="特記事項／相談事" />
          </span>
          <span class="obj-input">
            <div class="obj-header">
              <span class="label">次営業日の予定</span>
            </div>
            <textarea
              id="plan"
              v-model="plan"
              :disabled="!isMyself"
              type="text"
              placeholder="次営業日の予定" />
          </span>
          <span class="obj-input">
            <div class="obj-header">
              <span class="label">直近の予定</span>
            </div>
            <textarea
              id="event"
              v-model="event"
              :disabled="!isMyself"
              type="text"
              placeholder="直近の予定" />
          </span>
        </div>
      </div>
      <div class="footer">
        <span class="menu">
          <input
            v-if="teamsMailUse"
            id="01-A"
            :disabled="!teamsMailAddress"
            v-model="isSend"
            type="checkbox">
          <label
            v-if="isMyself && teamsMailUse"
            :title="!teamsMailAddress ? 'Teams投稿機能を利用する場合は\nTeams連絡先メールアドレスを設定してください' : ''"
            :class="{opacity03: !teamsMailAddress}"
            for="01-A"
            class="checkbox">Teamsに投稿する</label>
          <span
            v-if="isMyself"
            class="save-diary"
            @click="saveDiary">保存</span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import Moment from 'moment'
import {db} from '@/plugins/firestore'
import ms from '@/utils/msGraphApi'
import sw from '@/utils/sweetAlert'

export default {
  filters: {
    /**
     * HTML部で使うMomentのフォーマット
     * @param {String} value 変換される日付
     * @param {String} format フォーマットの書式
     * @returns {String} フォーマットされた後の日付
     */
    moment (value, format) {
      return Moment(value).format(format)
    }
  },
  props: {
    /**
     * フォームを開いたときに表示する日付ユーザーのID
     */
    propsUserId: {
      type: String,
      required: true
    },
    /**
     * フォームを開いたときに表示する日付
     */
    propsThisDate: {
      type: Moment,
      required: true
    },
  },
  data () {
    return {
      /**
       * 現在表示中のユーザーのID
       * @type {String}
       */
      userId: this.propsUserId,
      /**
       * 現在表示中の日付
       * @type {Moment}
       */
      thisDate: this.propsThisDate,
      /**
       * input type date用のthis.thisDateをフォーマットしたものを格納する器
       * @type {String}
       */
      inputDate: '',
      /**
       * 勤務開始時間(必須)
       * @type {String}
       */
      timeStart: '09:00',
      /**
       * 勤務終了時間(必須)
       * @type {String}
       */
      timeEnd: '18:00',
      /**
       * 休憩時間(必須)
       * @type {String}
       */
      timeBreak: '01:00',
      /**
       * 今日の気分(必須)
       * @type {Number}
       */
      feel: '',
      /**
       * 今日の実績(必須)
       * @type {String}
       */
      actual: '',
      /**
       * 総括(任意)
       * @type {String}
       */
      summary: '',
      /**
       * 特記事項／相談事(任意)
       * @type {String}
       */
      note: '',
      /**
       * 次営業日の予定(任意)
       * @type {String}
       */
      plan: '',
      /**
       * 直近の予定(任意)
       * @type {String}
       */
      event: '',
      /**
       * Teams投稿するかを判別
       * @type {Boolean}
       */
      isSend: true,
      /**
       * 取得した日報が投稿されている「日報」かを判別
       * @type {Boolean}
       */
      isDiary: false,
      /**
       * ユーザーがフォームで何かしらの編集を行ったことを判別
       * @type {Boolean}
       */
      isChange: false,
      /**
       * サインインユーザー本人のフォームかを判別(本人なら編集フォーム、他人なら参照フォーム)
       * @type {Boolean}
       */
      isMyself: false,
      /**
       * 読み込み中かを判別するフラグ
       * @type {Boolean}
       */
      isLoading: false,
      /**
       * Teams投稿機能を利用するかどうか
       * @type {Boolean}
       */
      teamsMailUse: true,
      /**
       * Teams投稿先メールアドレス
       * @type {String}
       */
      teamsMailAddress: ''
    }
  },
  computed: {
    /**
     * ユーザーの姓名をusersから取得し結合
     * @returns {String} ユーザーネーム
     */
    userName () { return this.$store.state.users.data.find(user => user.id === this.userId).name.last + ' ' + this.$store.state.users.data.find(user => user.id === this.userId).name.first },
    /**
     * firestoreから「日報」を取得する処理を短縮する目的のプロパティ
     * @returns {Object} 日報取得DBアクセスプロパティ
     */
    diary () { return db.collection(`tenants/${this.$store.state.tenant}` + '/users/' + this.userId + '/diary') },
    /**
     * firestoreから「下書き」を取得する処理を短縮する目的のプロパティ
     * @returns {Object} 下書き取得DBアクセスプロパティ
     */
    draft () { return db.collection(`tenants/${this.$store.state.tenant}` + '/users/' + this.userId + '/draft') }
  },
  mounted () {
    // 日報情報を取得
    this.getDiary()
    // [esc]キーが押された時フォームを閉じる
    document.onkeydown = (e) => {
      if (e.key === 'Escape') {
        this.isChange = this.isMyself
        this.close()
      } else if (e.ctrlKey && e.key === "s") {
        e.preventDefault()
        this.saveDiary()
      }
    }
    // teams投稿アドレスを取得
    db.doc(`tenants/${this.$store.state.tenant}`).get().then((doc) => {
      // firestoreにteamsMailが設定されていない場合、Teams投稿チェックボックスを非活性にして表示したいので
      // teamsMailUseをtrueにする
      this.teamsMailUse = doc.data().teamsMail ? doc.data().teamsMail.use : true
      this.teamsMailAddress = doc.data().teamsMail ? doc.data().teamsMail.address : ''

      // Teams投稿先メールアドレスが設定されていなかった場合にTeams投稿チェックボックス：OFF
      if (!this.teamsMailAddress) {
        this.isSend = false
      }
    }).catch((error) => {
      sw.toastAlert('error', '取得に失敗しました')
      console.error(`エラー:${error}`)
    })
  },
  methods: {
    /**
     * firestoreに「日報」を保存する
     */
    saveDiary () {
      // 必須項目入力チェック
      let errorMessage = ''
      if (this.timeStart === '' || this.timeStart === undefined) errorMessage += ' 勤務開始時間'
      if (this.timeEnd === '' || this.timeEnd === undefined) errorMessage += ' 勤務終了時間'
      if (this.timeBreak === '' || this.timeBreak === undefined) errorMessage += ' 休憩時間'
      if (this.feel === '' || this.feel === undefined) errorMessage += ' 今日の気分'
      if (this.actual === '' || this.actual === undefined) errorMessage += ' 今日の実績'
      // 必須項目が入力されていない場合はアラートを表示し処理終了
      if (errorMessage !== '') {
        sw.toastAlert('error', '『' + errorMessage + ' 』が入力されていません')
        return
      }
      // 休憩時間が勤務時間を越していたらアラートを表示し処理終了
      if (!this.validateBreakTime(this.timeStart, this.timeEnd, this.timeBreak)) {
        sw.toastAlert('error', '休憩時間が実働時間よりも長いです')
        return
      }
      this.$swal({
        icon: 'warning',
        text: '保存してもよろしいですか？',
        showCancelButton: true,
        reverseButtons: true
      }).then((result) => {
        // ユーザーが『OK』ボタンを押したら[sendMail]を呼び出す
        if (result.isConfirmed) {
          const date = this.thisDate.format('YYYY-MM-DD')
          // 「日報」を保存する
          this.diary.doc(date).set({
            date: date,
            timeStart: this.timeStart,
            timeEnd: this.timeEnd,
            timeBreak: this.timeBreak,
            feel: this.feel,
            actual: this.actual,
            summary: this.summary,
            note: this.note,
            plan: this.plan,
            event: this.event
          })
          // 「日報」が保存されたら「下書き」は不要になるので削除
          this.draft.doc(date).delete()
          // 保存した後、フォームを閉じる
          this.$emit('close')


          // Teams投稿機能：ON かつ Teams投稿チェックボックス：ONのみメール送信
          if (this.teamsMailUse && this.isSend) {
            sw.infoAlert('送信準備中...')
            this.sendDiaryToTeams()
            return
          }
          sw.toastAlert('success', '保存しました')
          this.$store.dispatch('getDiaries')
        }
      })
    },
    /**
     * 勤務時間と休憩時間を数値に直し、休憩時間が勤務時間を越していないかを調べる
     * @param {String} timeStart 勤務開始時間
     * @param {String} timeEnd 勤務終了時間
     * @param {String} timeBreak 休憩時間
     * @returns {Boolean} 越していなければtrue、越していればfalse
     */
    validateBreakTime (timeStart, timeEnd, timeBreak) {
      timeStart = Number(timeStart.split(':')[0]) + Number(timeStart.split(':')[1]) / 60
      timeEnd = Number(timeEnd.split(':')[0]) + Number(timeEnd.split(':')[1]) / 60
      timeBreak = Number(timeBreak.split(':')[0]) + Number(timeBreak.split(':')[1]) / 60
      return (timeEnd - timeStart >= timeBreak)
    },
    /**
     * firestoreにある「日報」を削除する
     */
    deleteDiary () {
      // SweetAlertで警告を表示する
      this.$swal({
        icon: 'warning',
        text: '日報を削除しますか？',
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonColor: '#ff3d0c'
      }).then((result) => {
        // ユーザーが『OK』ボタンを押したら「日報」を削除する。『Cancel』を押したら何もしない
        if (result.isConfirmed) {
          this.diary.doc(this.thisDate.format('YYYY-MM-DD')).delete()
          sw.toastAlert('success', '削除しました')
          this.$store.dispatch('getDiaries')
          this.$emit('close')
        }
      })
    },
    /**
     * firestoreにある「下書き」を破棄する
     */
    deleteDraft () {
      // SweetAlertで警告を表示する
      this.$swal({
        icon: 'warning',
        text: '下書きを削除しますか？',
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonColor: '#ff3d0c'
      }).then((result) => {
        // ユーザーが『OK』ボタンを押したら「下書き」を削除する。『Cancel』を押したら何もしない
        if (result.isConfirmed) {
          this.draft.doc(this.thisDate.format('YYYY-MM-DD')).delete()
          sw.toastAlert('success', '削除しました')
          this.$store.dispatch('getDiaries')
          this.$emit('close')
        }
      })
    },
    /**
     * 「日報」を取得する
     */
    getDiary () {
      const date = this.thisDate.format('YYYY-MM-DD')
      // フォームの内容を初期化
      this.timeStart = '09:00'
      this.timeEnd = '18:00'
      this.timeBreak = '01:00'
      this.feel = ''
      this.actual = ''
      this.summary = ''
      this.note = ''
      this.plan = ''
      this.event = ''
      this.isDiary = false
      this.isChange = false
      this.isShowSaveText = false
      this.isMyself = (this.$store.state.currentUser.id === this.userId)
      this.isLoading = true
      this.inputDate = date
      // 「日報」をユーザーIDと日付を元にfirestoreから取得
      this.diary.doc(date).get().then((doc) => {
        // 「日報」を取得出来たら、各情報を変数に格納
        if (doc.exists) {
          this.timeStart = doc.data().timeStart
          this.timeEnd = doc.data().timeEnd
          this.timeBreak = doc.data().timeBreak
          this.feel = doc.data().feel
          this.actual = doc.data().actual
          this.summary = doc.data().summary
          this.note = doc.data().note
          this.plan = doc.data().plan
          this.event = doc.data().event
          this.isDiary = true
          this.isLoading = false
        } else if (this.isMyself && !this.isDiary) {
          this.getDraft(date)
        } else {
          this.isLoading = false
        }
      })
    },
    /**
     * 「下書き」または「直近の日報」を取得する
     * @param {Moment} date 取得する日報の日付
     */
    getDraft (date) {
      // 「日報」を取得できなかった場合投稿されていないので「下書き」を取得を試みる
      this.draft.doc(date).get().then((doc) => {
        // 「下書き」を取得出来たら、各情報を変数に格納
        if (doc.exists) {
          this.timeStart = doc.data().timeStart
          this.timeEnd = doc.data().timeEnd
          this.timeBreak = doc.data().timeBreak
          this.feel = doc.data().feel
          this.actual = doc.data().actual
          this.summary = doc.data().summary
          this.note = doc.data().note
          this.plan = doc.data().plan
          this.event = doc.data().event
          this.isLoading = false
        } else {
          // 作成日より未来の「日報」が存在しなければ前営業日の「日報」の『今日の実績』『直近の予定』をコピーする
          // 作成日より未来の「日報」が存在すればコピーしない
          this.diary.where('date', '>=', Moment(date).format('YYYY-MM-DD')).orderBy('date', 'desc').limit(1).get().then((query) => {
            if(!query.empty) {
              this.isLoading = false
            } else {
              this.diary.where('date', '>=', Moment(date).add(-7, 'day').format('YYYY-MM-DD')).where('date', '<=', date)
                  .orderBy('date', 'desc').limit(1).get().then((query) => {
                    query.forEach((doc) => {
                      // 取得出来たら、各情報を変数に格納
                      if(doc.exists) {
                        this.actual = doc.data().plan
                        this.event = doc.data().event
                      }
                    })
                    this.isLoading = false
                  })
            }
          })
        }
      })
    },
    /**
     * Teamsに日報を投稿するために、Teamsのチャネルにメールを送信する
     */
    sendDiaryToTeams () {
      // ユーザーが日報アプリを使用している時、他のユーザーが送信先設定を変更した場合に対応するため
      // Firestoreに接続してメールアドレスを取得する
      db.doc(`tenants/${this.$store.state.tenant}`).get().then((doc) => {
        // 日報をメールの形式にフォーマットする ここから
        let message = ''
        if (this.note.trim() !== '') message += `■■ 特記事項／相談事 ■■\n${this.note}\n\n`
        if (this.actual.trim() !== '') message += `■■ 今日の実績 ■■\n${this.actual}\n\n`
        if (this.summary.trim() !== '') message += `■■ 総括 ■■\n${this.summary}\n\n`
        if (this.plan.trim() !== '') message += `■■ 次営業日の予定 ■■\n${this.plan}\n\n`
        if (this.event.trim() !== '') message += `■■ 直近の予定 ■■\n${this.event}\n\n`
        const mailContent = {
          message: {
            subject: `【日報：${this.thisDate.format('YYYY/MM/DD')} ${this.userName}】`,
            body: {
              contentType: 'Text',
              content: message.replace(/\r?\n/g, '\r\n')
            },
            toRecipients: [{
              emailAddress: {
                address: doc.data().teamsMail.address
              }
            }]
          }
        }
        ms.sendMail(JSON.stringify(mailContent), 'sendTeams')
      }).catch((error) => {
        sw.toastAlert('error', '投稿先の取得に失敗しました')
        console.error(`エラー:${error}`)
      })
    },
    /**
     * 日付が変更された時に、フォームの内容が編集されていたらアラートを出す
     * @param {String} mode 指定時刻はthis,昨日はprev,翌日はnext
     */
    setDate (mode) {
      // ロード中は日付変更をさせない
      if (this.isLoading) {
        return
      }
      // 翌日に遷移しようとして、遷移した日付が今日以降ならエラーを表示
      if (mode === 'next' && Moment(this.thisDate).add(1, 'day').isAfter(this.$store.state.today)) {
        sw.toastAlert('error', '未来の日報は入力・参照出来ません')
        return
      }
      // 編集されていなければ日付を変える
      if (!this.isChange || !this.isDiary) {
        this.switchDate(mode)
        return
      }
      // 編集されているならアラートを出す
      this.$swal({
        icon: 'warning',
        text: '保存されていない変更を破棄しますか？',
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonColor: '#ff3d0c'
      }).then((result) => {
        // ユーザーが『OK』ボタンを押したら、編集中のものを破棄し、日付を変える
        if (result.isConfirmed) {
          this.switchDate(mode)
        // 『Cancel』を押したら、<input type='date'>で日付を変えている場合、強制的にthis.thisDateの中身が変わってしまうので、日付を変更する前の日付を格納
        } else {
          this.inputDate = this.thisDate.format('YYYY-MM-DD')
        }
      })
    },
    /**
     * setDateで日付変更が許可されたらこのメソッドで日付を操作する
     * @param {String} mode 指定時刻はthis,昨日はprev,翌日はnext
     */
    switchDate (mode) {
      // もしthisが渡されたなら、指定時刻を格納。それ以外なら先月か翌月を格納
      switch (mode) {
        case 'this': {
          this.thisDate = Moment(this.inputDate)
          break
        }
        case 'next': {
          this.thisDate = Moment(this.thisDate).add(1, 'day')
          break
        }
        case 'prev': {
          this.thisDate = Moment(this.thisDate).add(-1, 'day')
          break
        }
      }
      // 自動セーブがかかっているなら一覧を更新する
      if (!this.isDiary && this.isChange) {
        this.$store.dispatch('getDiaries')
      }
      // 表示日付を変更したので新たに日報情報を取得
      this.getDiary()
    },
    /**
     * 新規日報の場合は自動セーブ、既存日報の場合はisChangeフラグを立たせる
     */
    change () {
      this.isChange = true
      if (this.isDiary) {
        return
      }
      const date = this.thisDate.format('YYYY-MM-DD')
      // 下書きを保存する
      this.draft.doc(date).set({
        date: date,
        timeStart: this.timeStart,
        timeEnd: this.timeEnd,
        timeBreak: this.timeBreak,
        feel: this.feel,
        actual: this.actual,
        summary: this.summary,
        note: this.note,
        plan: this.plan,
        event: this.event
      })
      sw.toastAlert('success', '自動保存しました')
    },
    /**
     * フォームを閉じる
     */
    close () {
      // 編集中でないならフォームを閉じる
      if (!this.isChange) {
        this.$emit('close')
        return
      }
      // 下書きなら更新してからフォームを閉じる
      if (this.isChange && !this.isDiary) {
        this.$store.dispatch('getDiaries')
        this.$emit('close')
        return
      }
      // 編集中ならアラートを出す
      this.$swal({
        icon: 'warning',
        text: '保存されていない変更を破棄しますか？',
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonColor: '#ff3d0c'
      }).then((result) => {
        // ユーザーが『OK』ボタンを押したらフォームを閉じる。『Cancel』を押したら何もしない
        if (result.isConfirmed) {
          this.$emit('close')
        }
      })
    }
  }
}
</script>

<style scoped>
.overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, .5);
  z-index: 1000;
  user-select: none;
}
.loading {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
}
.panel {
  width: 1200px;
  max-width: calc(100% - 20px);
  height: 682px;
  max-height: 100%;
  background: #f6f8f7;
  position: fixed;
  right: 50%;
  bottom: 50%;
  transform: translate(50%,50%);
  overflow: auto;
}
.header {
  height: 40px;
  width: 100%;
  min-width: 900px;
  background: #0E7BC6;
  color: #fff;
  position: sticky;
  font-size: 0.9em;
}
.footer {
  height: 40px;
  width: 100%;
  min-width: 900px;
  position: sticky;
  font-size: 0.9em;
  border-top: 1px solid #ccc;
  background: #fff;
}
.date {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 1.3em;
  font-weight: lighter;
}
.name {
  position: absolute;
  top: 50%;
  left: 1%;
  transform: translate(0%, -50%);
  font-size: 1.4em;
  font-weight: lighter;
}
.vertical-text {
  line-height: 1;
  vertical-align: middle;
}
.material-icons {
  color: #fff;
  font-family: 'Material Icons';
  font-weight: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  text-transform: none;
  white-space: nowrap;
  word-wrap: normal;
  direction: ltr;
  display: inline-flex;
  vertical-align: middle;
  cursor: pointer;
}
.menu {
  position: absolute;
  right: 1.5%;
  top: 50%;
  transform: translate(0%, -50%);
  font-weight: lighter;
}
.menu-label {
  display: inline-block;
  line-height: 1.428571429;
  vertical-align: middle;
  cursor: pointer;
}
.menu div {
  display: inline;
}
.vertical-line {
  margin: 0 5px;
  line-height: 1.428571429;
  vertical-align: middle;
  border-left: 1px solid #FFFFFF99;
  height: 100%;
}
.save-diary {
  background-color: #cc0000;
  color: #ffffff;
  background-image: none;
  display: inline-block;
  padding: 5px 15px;
  margin-bottom: 0;
  font-size: 1em;
  line-height: 1.428571429;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  cursor: pointer;
  border: 1px solid transparent;
  border-radius: 3px;
}
.form {
  display: flex;
  height: 600px;
  min-width: 900px;
}
.left-form,
.right-form {
  overflow: auto;
  width: 100%;
  margin-right: 10px;
}
.left-form {
  margin-top: 5px;
  margin-left: 10px;
}
.obj {
  position: relative;
  background-color: #ffffff;
  font-size: 0.9em;
}
.obj-input {
  box-sizing: border-box;
}
.obj-header {
  height: 15px;
  margin: 3px 0;
  padding: 5px 0 5px 10px;
  font-size: 0.9em;
  display: flex;
  background-color: #f6f8f7;
}
.obj-time,.obj-select {
  margin: 5px 0 0 0;
  padding: 10px;
  display: flex;
  align-items:center;
}
.obj-time {
  height: 80px;
}
.obj-select {
  height: 20px;
}
.label {
  color: #333;
  font-size: 0.8em;
}
input[type='time'],
input[type='date'] {
  width: 154px;
  height: 30%;
  transform: translate(0%, -50%);
  padding: 6px 0px;
  font-size: 1.4em;
  font-weight: bold;
  line-height: 1.428571429;
  color: #333;
  vertical-align: middle;
  background-color: #ffffff;
  border: none;
}
input[type='time']{
  height: 15%;
}
.work-date {
  position: absolute;
  right: 2%;
  top: 50%;
  transform: translate(0%, -50%);
}
.work-time-start-label {
  position: absolute;
  right: 35%;
  top: 20%;
  transform: translate(0%, -50%);
}
.work-time-start {
  position: absolute;
  right: 2%;
  top: 20%;
  transform: translate(0%, -50%);
}
.work-time-end-label {
  position: absolute;
  right: 35%;
  top: 50%;
  transform: translate(0%, -50%);
}
.work-time-end {
  position: absolute;
  right: 2%;
  top: 50%;
  transform: translate(0%, -50%);
}
.work-time-break-label {
  position: absolute;
  right: 35%;
  top: 80%;
  transform: translate(0%, -50%);
}
.work-time-break {
  position: absolute;
  right: 2%;
  top: 80%;
  transform: translate(0%, -50%);
}
textarea {
  width: 100%;
  height: 164px;
  font-size: 0.75em;
  padding: 5px 0 0 10px;
  border: 0px;
  display: block;
  resize: vertical;
  box-sizing: border-box;
  font-family: 'Source Sans Pro',arial,sans-serif;
}
textarea:focus {
  outline: none;
  border: 2px solid #0E7BC6;
}
textarea#note {
  height: 169px;
}
.feel {
  display: flex;
  position: absolute;
  right: 1%;
  top: 52%;
  transform: translate(0%, -50%);
  flex-direction: row-reverse;
}
.feel label{
  padding: 0px 7px 0px;
}
.feel input[type='radio']{
  display: none;
}
.myFeel label:hover {
  color: gray;
}
.material-icons-outlined {
  font-size: 1.7em;
  color: #b8b8b8
}
.feel input[type='radio']:checked + label .sentiment_very_satisfied {
  color: #009688;
  opacity: 0.6;
}
.feel input[type='radio']:checked + label .mood {
  color:#498205;
  opacity: 0.6;
}
.feel input[type='radio']:checked + label .sentiment_satisfied {
  color: #0e7bc6;
  opacity: 0.6;
}
.feel input[type='radio']:checked + label .sentiment_dissatisfied {
  color: #744da9;
  opacity: 0.6;
}
.feel input[type='radio']:checked + label .sentiment_very_dissatisfied {
  color: #f44336;
  opacity: 0.6;
}
/* 必須マーク */
.must {
  color: #FF1A00;
  font-size: 0.85em;
}
/* チェックボックス01 */
input[type=checkbox] {
  display: none;
}
.checkbox {
  box-sizing: border-box;
  cursor: pointer;
  display: inline-block;
  padding: 5px 30px;
  position: relative;
  width: auto;
}
.checkbox::before {
  background: #fff;
  border: 1px solid #231815;
  content: '';
  display: block;
  height: 16px;
  left: 5px;
  margin-top: -8px;
  position: absolute;
  top: 50%;
  width: 16px;
}
.checkbox::after {
  border-right: 3px solid #ed7a9c;
  border-bottom: 3px solid #ed7a9c;
  content: '';
  display: block;
  height: 9px;
  left: 10px;
  margin-top: -7px;
  opacity: 0;
  position: absolute;
  top: 50%;
  transform: rotate(45deg);
  width: 5px;
}
input[type=checkbox]:checked + .checkbox::after {
  opacity: 1;
}
input[type='date']::-webkit-clear-button,
input[type='time']::-webkit-clear-button {
  display: none;
}
:disabled {
  color: #000;
  background: #fff;
}
.opacity03 {
  opacity: 0.3;
}
</style>



// WEBPACK FOOTER //
// src/components/modules/DailyReport/Form.vue